import { shareOrigin } from "@/lib/origin";
import { motion } from "framer-motion";
import { Share2, Mic, Gift, Copy, Award, Play } from "lucide-react";
import { copyOut, personalLink } from "@/lib/partnerKit";
import PostToday from "@/components/partner/PostToday";
import FoundingBadge from "@/components/partner/FoundingBadge";

const TIER = { partner: "Xcelio Partner", select: "Select Partner", vip: "VIP Partner" };
const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

function BigAction({ icon: Icon, label, sub, to, testId }) {
  return (
    <button onClick={() => go(to)} data-testid={testId}
      className="group flex-1 min-w-0 rounded-2xl border border-primary/30 bg-primary/[0.06] px-5 py-5 text-left hover:bg-primary/[0.12] hover:-translate-y-0.5 transition-[background-color,transform] duration-200">
      <Icon className="w-5 h-5 text-primary mb-4" strokeWidth={1.6} />
      <span className="block text-[13px] font-semibold tracking-[0.14em] uppercase">{label}</span>
      <span className="block text-xs text-muted-foreground mt-1">{sub}</span>
    </button>
  );
}

export default function HubHeader({ k, onWelcome }) {
  const link = personalLink(k.slug);
  return (
    <section className="mb-10" data-testid="partner-hub-header">
      <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
        <div className="flex flex-wrap items-center gap-3 mb-4">
          <p className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.22em] text-primary" data-testid="partner-tier"><Award className="w-3.5 h-3.5" /> {TIER[k.tier] || TIER.partner}</p>
          {k.founding && <FoundingBadge />}
        </div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05]" data-testid="partner-welcome">Welcome, {k.name || "Partner"}.</h1>
        <p className="font-serif italic text-xl sm:text-2xl text-foreground/70 mt-2">You're an Xcelio Partner.</p>
        <button onClick={onWelcome} className="mt-3 inline-flex items-center gap-1.5 text-xs text-primary hover:underline" data-testid="partner-hear-welcome"><Play className="w-3.5 h-3.5" /> Hear Adelaida's welcome</button>
      </motion.div>
      <div className="mt-8 grid sm:grid-cols-3 gap-3">
        <button onClick={() => copyOut(link)} className="rounded-2xl border border-border bg-card/40 p-4 text-left hover:border-primary/40 transition-colors duration-200 min-w-0" data-testid="partner-link-copy">
          <span className="block text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Your link</span>
          <span className="flex items-start gap-2 mt-1.5 text-sm" data-testid="partner-link"><span className="break-all">{shareOrigin().replace(/^https?:\/\//, "")}<span className="text-primary font-semibold">/{k.slug}</span></span><Copy className="w-3.5 h-3.5 text-primary shrink-0 mt-0.5" /></span>
        </button>
        <button onClick={() => copyOut(k.code)} className="rounded-2xl border border-border bg-card/40 p-4 text-left hover:border-primary/40 transition-colors duration-200" data-testid="partner-code-copy">
          <span className="block text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Your code</span>
          <span className="flex items-center gap-2 mt-1.5 text-sm font-semibold tracking-wider" data-testid="partner-code">{k.code}<Copy className="w-3.5 h-3.5 text-primary" /></span>
        </button>
        <div className="rounded-2xl border border-border bg-card/40 p-4" data-testid="partner-commission">
          <span className="block text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Your commission</span>
          <span className="block mt-1.5 text-sm">{Math.round(k.rate * 100)}% for {k.months} months</span>
        </div>
      </div>
      <div className="mt-4 flex flex-col sm:flex-row gap-3">
        <BigAction icon={Share2} label="Share Xcelio" sub="Ready-made posts with your link" to="share" testId="hub-action-share" />
        <BigAction icon={Mic} label="Send a personal invite" sub="Adelaida says hello by name" to="invite" testId="hub-action-invite" />
        <BigAction icon={Gift} label="Gift a Reset" sub="Give someone 90 seconds" to="gift" testId="hub-action-gift" />
      </div>
      <PostToday k={k} />
    </section>
  );
}
